import type { ComponentProps, ReactElement } from 'react'
// @qc-ignore icon button composes sibling components within the same public module
import { Button } from '../Button'
// @qc-ignore icon button composes sibling components within the same public module
import type { Icon } from '../Icon'
import style from './style.module.sass'

export const IconButton = (
	props: ComponentProps<typeof Button> & {
		children: ReactElement<ComponentProps<typeof Icon>>
	}
) => {
	return (
		<Button
			{...props}
			compact={props.compact ?? true}
			className={`${style.button} ${props.className ?? ''}`}
		>
			{props.children}
		</Button>
	)
}
